import { render, staticRenderFns } from "./ProductOrderList.vue?vue&type=template&id=fa994bb2&scoped=true&"
import script from "./ProductOrderList.vue?vue&type=script&lang=js&"
export * from "./ProductOrderList.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrderList.vue?vue&type=style&index=0&id=fa994bb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa994bb2",
  null
  
)

export default component.exports